type Result<T, E = Error> = { data: T; error: undefined } | { data: undefined; error: E }

export function tryCatch<T, E = Error>(fn: () => T): Result<T, E> {
  try {
    const data = fn()
    return { data: data, error: undefined }
  } catch (error) {
    return { data: undefined, error: error as E }
  }
}

export async function tryCatchAsync<T, E = Error>(fn: () => Promise<T>): Promise<Result<T, E>> {
  try {
    const data = await fn()
    return { data: data, error: undefined }
  } catch (error) {
    return { data: undefined, error: error as E }
  }
}
